<template>
  <tr class="screener-participant-row">
    <td class="screener-participant-col" style="width:5%;">
      <profile-preview-image
        :profileId="user.owner.profileId"
        :uuid="user.owner.uuid"
        :avatarSize="48"
        :avatarClasses="['screener-participant__avatar', 'avatar', 'rounded']"
        :imageClasses="['screener-participant-card__avatar']"
        :thumbnailUrl="user.owner.thumbnailUrl"
      />
    </td>
    <td class="screener-participant-col" style="width: 30%">
      <h4 class="screener-participant__name" v-if="user.owner">
        {{ user.owner.firstName }} {{ user.owner.lastName }}
      </h4>
      <p>
        <span class="pr-2">{{ user.owner.lastName ? 'Participant' : 'Not registered' }}</span>
      </p>
    </td>
    <td class="screener-participant-col" style="width:10%;">
      <v-chip
        x-small
        color="accent"
      >{{user.status.toLowerCase()}}</v-chip>
    </td>
    <td class="screener-participant-col" style="width:10%;">
        <span class="bhGray2--text text-nowrap">
          {{ user.creationDate | moment('MMMM Do YYYY, hh:MM A') }}
        </span>      
    </td>
    <td class="screener-participant-col" style="width:10%;">
        <span class="bhGray2--text text-nowrap">
          {{ user.endDate | moment('MMMM Do YYYY, hh:MM A') }}
        </span>      
    </td>
    <td class="screener-participant-col" style="width:10%;">
      <strong class="accent--text">
        {{ user.score }}
      </strong>
    </td>
    <td class="screener-participant-col" style="width:10%;">
      <v-btn
        v-if="user.status=='COMPLETED'"
        icon
        color="accent"
        elevation="0"
        @click="$emit('to-screener', user.id, user.owner.participantId)"
      >
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>
import ProfilePreviewImage from '../profile/ProfilePreviewImage.vue'
export default {
  components: { ProfilePreviewImage },
  name: 'PatientScreenersTableRow',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data: () => ({}),
  methods: {
  },
}
</script>

<style lang="scss">
.screener-participant {
  &__name {
    min-width: 150px;
    max-width: 200px;
    margin-bottom: 4px;
  }

  &__avatar {
    overflow: hidden;
    border-radius: 8px;
    width: 48px;
    height: 48px;
    .v-image {
      object-fit: cover;
      height: 100%;
      width: 100%;
    }
  }

  &-row {
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.04);
    border-radius: $border-radius-root;

    &:hover {
      background: transparent !important;
    }
  }

  &-col {
    padding: 8px !important;
    border-bottom: 0 !important;
    background: $bh-white;

    strong {
      display: inline-block;
      margin-bottom: 4px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    p {
      font-size: 0.857rem;
      line-height: 1rem;
      &.wrapped {
        overflow: hidden;
        text-overflow: ellipsis;
        width: 300px;
        white-space: nowrap;
        margin-bottom: 0;
        &::after {
          content: '';
          display: block;
        }
      }
    }

    p:last-child {
      margin-bottom: 0;
    }

    &:first-of-type {
      min-width: 0;
      border-top-left-radius: $border-radius-root;
      border-bottom-left-radius: $border-radius-root;
    }

    &:last-of-type {
      min-width: 0;
      border-top-right-radius: $border-radius-root;
      border-bottom-right-radius: $border-radius-root;
    }
    &--full {
      width: 100%;
    }
  }
}
</style>
